import { render } from "./ModalRegister.vue?vue&type=template&id=273ca49b&scoped=true"
import script from "./ModalRegister.vue?vue&type=script&lang=js"
export * from "./ModalRegister.vue?vue&type=script&lang=js"

import "./ModalRegister.vue?vue&type=style&index=0&id=273ca49b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273ca49b"]])

export default __exports__